"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var react_styles_1 = require("@patternfly/react-styles");

var dropdownConstants_1 = require("./dropdownConstants");

exports.DropdownGroup = function (_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label;
  return React.createElement(dropdownConstants_1.DropdownContext.Consumer, null, function (_ref2) {
    var sectionClass = _ref2.sectionClass,
        sectionTitleClass = _ref2.sectionTitleClass,
        sectionComponent = _ref2.sectionComponent;
    var SectionComponent = sectionComponent;
    return React.createElement(SectionComponent, {
      className: react_styles_1.css(sectionClass, className)
    }, label && React.createElement("h1", {
      className: react_styles_1.css(sectionTitleClass),
      "aria-hidden": true
    }, label), React.createElement("ul", {
      role: "none"
    }, children));
  });
};

exports.DropdownGroup.displayName = 'DropdownGroup';